var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:_vm.buttonClass,attrs:{"color":_vm.isTablet ? '' : 'primary',"large":!_vm.isTablet},on:{"click":_vm.navigateHome}},[_c('v-icon',{attrs:{"left":"","size":_vm.iconSize}},[_vm._v("mdi-arrow-left")]),_vm._v(" "+_vm._s(_vm.isTablet ? 'Packlisten' : 'Zurück zu den Packlisten')+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }